import React from 'react'
import {
  SectionCard,
  SelectionBoxGroup,
  type SelectionBoxOption,
} from '@enamelai/design-system'
import { useTheme } from '@context/ThemeContext'
import type { ThemePreference } from '@utils/theme.util'
import './AppearanceStyle.css'

const THEME_OPTIONS: SelectionBoxOption[] = [
  {
    value: 'system',
    title: 'System',
    description: "Follows your device's light or dark setting",
  },
  {
    value: 'light',
    title: 'Light',
    description: 'Always use the light theme',
  },
  {
    value: 'dark',
    title: 'Dark',
    description: 'Always use the dark theme',
  },
]

const Appearance = (): React.ReactElement => {
  const { preference, setPreference } = useTheme()

  return (
    <div className="settings-appearance">
      <SectionCard
        title="Theme"
        radius="md"
        className="settings-appearance-card"
      >
        <p className="settings-appearance-description">
          Saved on this browser and applied right away.
        </p>
        <SelectionBoxGroup
          name="theme-preference"
          label="Theme"
          value={preference}
          options={THEME_OPTIONS}
          onChange={(value) => setPreference(value as ThemePreference)}
          className="settings-appearance-options"
        />
      </SectionCard>
    </div>
  )
}

export default Appearance
